import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { EMPTY, filter, Observable, of } from 'rxjs';

import { selectProfileByType } from '@era/stores';
import { DeviceInformation } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel, isNotUndefined } from '@rocksoft/shared';

import { AppleDevicePowerComponent } from './apple-device-power.component';

@Component({
  selector: 'ml-mdm-apple-device-power',
  templateUrl: './apple-device-power.container.html',
  styleUrls: [],
  imports: [AppleDevicePowerComponent, AsyncPipe],
})
export class AppleDevicePowerContainerComponent implements OnInit {
  private readonly store = inject(Store);

  appleDeviceInformation$: Observable<DeviceInformation>;
  public error: ErrorModel;

  ngOnInit() {
    this.appleDeviceInformation$ = this.store
      .select(selectProfileByType('device-information'))
      .pipe(filter(isNotUndefined));
  }

  handleError(error: ErrorModel): Observable<DeviceInformation | null> {
    if (error.status && error.status === 404) {
      // TODO Log as error
      return of<DeviceInformation | null>(null);
    }
    this.error = error;
    return EMPTY;
  }
}
